import React from "react";

const ChartData = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M2 19.778h8V34H2V19.778ZM14 2h8v32h-8V2Zm12 8.889h8V34h-8V10.889Z"
            fill={fill}
        />
    </svg>
);

export default ChartData;